import React, { Fragment } from "react";
import styled from 'styled-components';
import I10n from '../../../features/i10n';
import MsxIcons from '../../msx-icons';
import Scrollbars from 'react-custom-scrollbars';
import { front_base_url, configurationModuleType, m580_distributed_ranges, m580_complex_connection_colors, m580_hotstandby_ranges, RENDER_M580_ARCHITECTURE_SCHEMA } from '../../../constants';
import Device from '../../../models/Device';
import { PRIMARY_COLOR } from "../../../color-constants";

const Container = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: white;
  color: #333333;
  box-sizing: content-box;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background-color: white;
  color: ${PRIMARY_COLOR};
  color: var(--se-primary, ${PRIMARY_COLOR});
  margin: 0px 20px;
  padding: 10px 0px;
`;

const Subtitle = styled.div`
  font-size: 14px;
  color: #626469;
  margin-top: 5px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

const Title = styled.span`
  font-weight: bold;
  font-size: 20px;
`;

const CloseIcon = styled.span`
  display: inline-block;
  color: #626469;
  cursor: pointer;
`;

const Content = styled.div`
  flex: 1 1 0px;
  display: flex;
  margin: 10px 0px;
  overflow: hidden;
  background-color: #fafafa;
  box-shadow: inset 0 0 15px 1px rgba(0,0,0,0.1);

  border-top: 2px solid #cccccc;
`;

const InlineRow = styled.div`
  position: relative;
  display: inline-block;
  ${props => props.paddingLeft ? `padding-left: ${props.paddingLeft}px;` : ''}
`;

const ScrollbarContent = styled.div`
  display: inline-block;
  margin: ${props => props.showDimensions ? 30 : 15}px 15px 15px 15px;
`;

const GraphicalViewItem = styled.div`
  position: relative;
  height: 100%;
`;

const BlockModulesWrapper = styled.div`
  display: inline-block;
  position: absolute;
  right: 0px;
`;

const ModuleWithBusWrapper = styled.div`
  display: inline-block;
  vertical-align: top;
`;

const ModuleItem = styled(GraphicalViewItem)`
  display: inline-block;
  height: ${props => props.height ? props.height : 160}px;
  z-index: 1;
  position: relative;
`;

const ModuleInput = styled.input`
  position: absolute;
  opacity: 0.00001;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  z-index: -1;
`;

const DeviceImageWrapper = styled.label`
  display: block;
  position: relative;

  :after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    box-sizing: border-box;

    ${props => props.selected && `
      border: 4px solid ${PRIMARY_COLOR};
      border-radius: 2px;
      background-color: rgba(66, 180, 230, 0.25);
    `}
  }
`;

const DeviceImage = styled.img`
  display: block;
  height: ${props => `${props.height}px`};
  width: ${props => `${props.width}px`};
  font-size: 8px;
  writing-mode: vertical-lr;
  text-orientation: upright;
  text-align: center;
`;

const ProtocolHorizontalLine = styled.div`
  position: absolute;
  right: ${props => props.right ? props.right : 0 }px;
  ${props => props.bottom != null && `bottom: ${props.bottom}px;`}
  ${props => props.top != null && `top: ${props.top}px;`}
  background-color: black;
  width: ${props => props.width}px;
  height: 5px;
  z-index: 1;
`;

const ProtocolVerticalLine = styled.div`
  position: absolute;
  right: ${props => props.right ? props.right : 0 }px;
  ${props => props.bottom != null && `bottom: ${props.bottom}px;`}
  ${props => props.top != null && `top: ${props.top}px;`}
  background-color: black;
  height: ${props => props.height}px;
  width: 5px;
  z-index: 1;
`;

const ProtocolText = styled.span`
  position: absolute;
  right: 0px;
  font-size: 10px;
  ${props => props.bottom != null && `bottom: ${props.bottom}px;`}
`;

const IslandAndRedboxesContainer = styled.div`
  display: flex;
`;

const IslandAndLocalRacksContainer = styled.div`
  display: flex;
  flex-direction: ${props => props.isIslandHotstandby ? 'row' : 'column'};
`;

const IslandWithBusWrapper = styled.div`
  position: relative;
  display: inline-block;
  min-width: ${props => props.width}px;
  max-width: ${props => props.width}px;
  ${props => props.paddingLeft ? `padding-left: ${props.paddingLeft}px;` : ''}
  height: 160px;
  margin-bottom: 40px;
`;

const ViewWrapper = styled.div`
  display: inline-block;
`;

const RackWrapper = styled.div`
  position: relative;
  display: inline-block;
  height: ${props => `${props.height}px`};
  width: ${props => `${props.width}px`};
`;

const RackImage = styled.img`
  position: absolute;
  display: block;
  height: ${props => `${props.height}px`};
  width: ${props => `${props.width}px`};
  opacity: 0.3;
`;

const ModulesWithHintWrapper = styled.div`
  display: inline-block;
  position: relative;
  vertical-align: top;
`;

const EmptySpace = styled.div`
  display: inline-block;
  width: ${props => props.width}px;
  height: 160px;
`;

const M580VerticalWire = styled.div`
  position: absolute;
  display: flex;
  ${props => props.horizontalPosition != null ? `right: calc(${props.horizontalPosition}px);` : ''}
  ${props => props.verticalPosition != null ? `top: ${props.verticalPosition}px;` : ''}
  height: ${props => props.height ? `${props.height}` : '20'}px;
  width: 6px;
  background-color: ${props => props.color};
`;

const M580HorizontalLineConnector = styled.div`
  position: absolute;
  z-index: 2;
  display: flex;
  ${props => props.top != null ? `top: ${props.top}px;` : ''}
  ${props => props.right != null ? `right: ${props.right}px;` : ''}
  ${props => props.width != null ? `width: ${props.width}px;` : ''}
  height: 6px;
  background-color: ${props => props.color};
`;

const M580VerticalLineConnector = styled.div`
  position: absolute;
  display: flex;
  top: ${props => props.top ? props.top : 0}px;
  right: ${props => props.right ? props.right : 0}px;
  bottom: ${props => props.bottom ? props.bottom : 0}px;
  width: 6px;
  background-color: ${props => props.color};
`;

const M580HorizontalWire = styled.div`
  position: absolute;
  display: flex;
  ${props => props.horizontalPosition != null ? `right: ${props.horizontalPosition}px;` : ''}
  ${props => props.verticalPosition != null ? `top: ${props.verticalPosition}px;` : ''}
  height: 6px;
  ${props => props.width ? `width: calc(${props.width}px + 6px);` : ''}
  background-color: ${props => props.color};
`;

const M580LocalHorizontalLineConnector = styled.div`
  position: absolute;
  ${props => props.top != null ? `top: ${props.top}px;` : ''}
  ${props => props.right != null ? `right: ${props.right}px;` : ''}
  ${props => props.width != null ? `width: ${props.width}px;` : ''}
  height: 6px;
  background-color: ${props => props.color};
`;

const M580LocalVerticalLineConnector = styled.div`
  position: absolute;
  ${props => props.top != null ? `top: ${props.top}px;` : ''}
  ${props => props.right != null ? `right: ${props.right}px;` : ''}
  ${props => props.left != null ? `left: ${props.left}px;` : ''}
  ${props => props.bottom != null ? `bottom: ${props.bottom}px;` : ''}

  width: 6px;
  background-color: ${props => props.color};
`;

const LocalRacksWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

class ModalPreviewPacConfiguration extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showDimensions: true,
    }
  }

  // On mount and if there is a module hightlighted, scroll to this module
  componentDidMount() {
    if (this._highlightedModuleElement && this._scrollElement) {

      this._scrollElement.view.scrollTop = Math.max(0, (this._highlightedModuleElement.getBoundingClientRect().y - 100.0));
      this._scrollElement.view.scrollLeft = Math.max(0, (this._highlightedModuleElement.getBoundingClientRect().x - 70.0));
    }
  }

  computeModuleHeight = (realHeight, maxModuleHeight) => {
    const heightRatio = Math.ceil(100 * realHeight / maxModuleHeight) / 100;
    return Math.floor(160 * (heightRatio ? heightRatio.toFixed(2) : 1));
  }

  computeModuleWidth = (realWidth, realHeight, newHeight) => {
    const aspectRatio = realWidth / realHeight;

    return Math.ceil(newHeight * (aspectRatio ? aspectRatio.toFixed(2) : 1));
  }

  shouldModuleBeHighlighted = (moduleSlot, moduleType, moduleIslandSlot, rackLocation) => {
    let result = false;

    if (this.props.moduleToHighlightProps != null && this.props.moduleToHighlightProps.moduleSlot != null && this.props.moduleToHighlightProps.moduleType != null && this.props.moduleToHighlightProps.moduleIslandSlot != null) {
      // eslint-disable-next-line eqeqeq
      if (this.props.moduleToHighlightProps.moduleSlot === moduleSlot && this.props.moduleToHighlightProps.moduleType === moduleType && this.props.moduleToHighlightProps.moduleIslandSlot === moduleIslandSlot && this.props.moduleToHighlightProps.moduleRackLocation == rackLocation) {
        result = true;
      }
    }

    return result;
  }

  setHighlightedModuleRef = element => {
    this._highlightedModuleElement = element;
  };

  renderModule = (device, maxModuleHeight, maxIslandHeight, cartridges, moduleProps = {}, configuration, selected = false) => {
    const slot = device.slot;
    const moduleType = device.moduleType;
    const realHeight = device.height ? device.height : 0;
    const realWidth = device.width ? device.width : 0;
    const imageHeight = this.computeModuleHeight(realHeight, maxModuleHeight);
    const imageWidth = this.computeModuleWidth(realWidth, realHeight, imageHeight);

    const { 'item': itemProps = {}, 'image': imageProps = {} } = moduleProps;
    return (
      <>
        <ModuleItem height={maxIslandHeight} key={`${device.id}_${slot}`} {...itemProps}>
          <ModuleInput
            id={`${device.id}_${slot}`}
            type="radio" name="config_module"
            className={`${device.validator.valid ? 'valid' : 'invalid'}`}
            checked={moduleType === this.state.typeModuleSelected && slot === this.state.slotModuleSelected}
            onChange={() => { }}
          ></ModuleInput>
          <DeviceImageWrapper ref={(elt) => { if (selected) { this.setHighlightedModuleRef(elt); } }} htmlFor={`${device.id}_${slot}`} {...imageProps} selected={selected}>
            <DeviceImage
              src={`${front_base_url}/images/small-devices-images/${device.id}_h320px.png`}
              alt={`${device.id} module front view`}
              onError={(e) => { e.target.onerror = null; e.target.src = device.sidePicture }}
              height={imageHeight}
              width={imageWidth}
            >
            </DeviceImage>
          </DeviceImageWrapper>
        </ModuleItem>
      </>
    );
  };

  renderHeadModule = (maxModuleHeight, islandMaxHeight, configuration, islandSlot, rackLocation) => {
    const device = configuration.headModule;
    const cartridges = configuration.cartridges;

    const moduleProps = { 'item': {}, 'image': {} };
    return (
      <>
        {this.renderModule(device, maxModuleHeight, islandMaxHeight, cartridges, moduleProps, configuration, this.shouldModuleBeHighlighted(device.slot, device.moduleType, islandSlot, rackLocation))}
      </>
    );
  }

  renderConfiguration = (maxModuleHeight, configuration) => {
    let maxWidth = configuration.rack?.width || 0;
    let maxHeight = configuration.rack?.height || 0;

    configuration.localRacks.forEach(conf => {
      if (maxWidth < conf.rack?.width) {
        maxWidth = conf.rack?.width;
        maxHeight = conf.rack?.height;
      }
    });

    configuration.ioIslands.forEach(island => {

      island.configuration?.localRacks.forEach(conf => {
        if (maxWidth < conf.rack?.width) {
          maxWidth = conf.rack?.width;
          maxHeight = conf.rack?.height;
        }
      });

      if (maxWidth < island.configuration?.rack?.width) {
        maxWidth = island.configuration?.rack?.width;
        maxHeight = island.configuration?.rack?.height;
      }
    });

    const imageRackHeight = this.computeModuleHeight(maxHeight, maxModuleHeight);
    const maxRealWidth = this.computeModuleWidth(maxWidth, maxHeight, imageRackHeight);

    const useLocalRackDisplayForIslands = !m580_distributed_ranges.includes(configuration?.rangeInfo?.rangeName);

    const islandsToDraw = [];

    const opticalFiberConnection = configuration.opticalFiberConnectionSchema();

    // If main rack and last rack connected via optical fiber, use the appropriate color.
    const mainRackAndLastRackConnectionColor = opticalFiberConnection[0] && opticalFiberConnection[opticalFiberConnection.length - 1] ? m580_complex_connection_colors.optical_fiber : m580_complex_connection_colors.classic;

    let previousDistanceHeadModule = this.computeHeadModuleDistance(configuration, maxModuleHeight, configuration.rack?.width || 0, configuration.rack?.height || 0, maxRealWidth, opticalFiberConnection, 0);

    islandsToDraw.push(this.renderIsland(maxModuleHeight, maxRealWidth, configuration, 0, (configuration.ioIslands.length === 0), previousDistanceHeadModule, { rightDistanceTop: 0, rightDistanceBottom: 0}, mainRackAndLastRackConnectionColor, false, useLocalRackDisplayForIslands));
    configuration.ioIslands.forEach((island, idx) => {
      const previousDistance = previousDistanceHeadModule;
      const realRackHeight = island.configuration.rack?.height || 0;
      const realRackWidth = island.configuration.rack?.width || 0;
      previousDistanceHeadModule = this.computeHeadModuleDistance(island.configuration, maxModuleHeight, realRackWidth, realRackHeight, maxRealWidth, opticalFiberConnection, idx + 1);
      islandsToDraw.push(this.renderIsland(maxModuleHeight, maxRealWidth, island.configuration, island.slot, (idx + 1) === configuration.ioIslands.length, previousDistanceHeadModule, previousDistance, mainRackAndLastRackConnectionColor, true, useLocalRackDisplayForIslands));
    });

    return (<>
      {islandsToDraw.map((island, idx) => <Fragment key={idx}>{island}</Fragment> )}
    </>);
  }

  getModuleAtSlot = (configuration, slot, moduleType) => {
    let mod;
    switch (moduleType) {
      case configurationModuleType.head_module:
        mod = configuration.headModule;
        break;
      case configurationModuleType.com_module:
        mod = configuration.comModules.find(m => m.slot === slot);
        break;
      case configurationModuleType.io_module:
        mod = configuration.ioModules.find(m => m.slot === slot);
        break;
      default:
        break;
    }

    return new Device(mod);
  }


  renderPacPowerSupplies = (maxModuleHeight, islandMaxHeight, configuration, islandSlot, rackLocation) => {
    let components = [];

    let total = configuration.rack?.maxPowerSupplies || 0;

    let emptySpaceWidth = 40;

    if (configuration.rack) {
      const realRackHeight = configuration.rack?.height ? configuration.rack.height : 0;
      const imageRackHeight = this.computeModuleHeight(realRackHeight, maxModuleHeight);
      emptySpaceWidth = this.computeModuleWidth(67.6, realRackHeight, imageRackHeight);
    }

    for (let i = 0; i < total; i++) {

      const modAtSlot = this.getModuleAtSlot(configuration, (i + 1), configurationModuleType.com_module);

      if (modAtSlot.id.length > 0) {
        components.push(
          <ModuleWithBusWrapper key={i}>
            <InlineRow paddingLeft={0}>
              {this.renderModule(modAtSlot, maxModuleHeight, islandMaxHeight, [], {}, configuration, this.shouldModuleBeHighlighted(modAtSlot.slot, modAtSlot.moduleType, islandSlot, rackLocation))}
            </InlineRow>
          </ModuleWithBusWrapper>
        );
      } else {
        components.push(
          <EmptySpace width={emptySpaceWidth}></EmptySpace>
        );
      }
    }
    return (<>
      {components.length > 0 && <>
        {components.map((component, idx) => {
          return <React.Fragment key={idx}>{component}</React.Fragment>
        })
        }</>}
    </>);
  }

  renderPacIoModules = (maxModuleHeight, islandMaxHeight, configuration, islandSlot, rackLocation) => {
    let components = [];

    let emptySpaceWidth = 40;

    if (configuration.rack) {
      const realRackHeight = configuration.rack?.height ? configuration.rack.height : 0;
      const imageRackHeight = this.computeModuleHeight(realRackHeight, maxModuleHeight);
      emptySpaceWidth = this.computeModuleWidth(32, realRackHeight, imageRackHeight);
    }

    let total = configuration.rack?.maxIoModules || 0;

    for (let i = 0; i < total; i++) {
      const modAtSlot = this.getModuleAtSlot(configuration, (i + 1), configurationModuleType.io_module);
      if (modAtSlot.id.length > 0) {
        components.push(
          <ModuleWithBusWrapper key={i}>
            <InlineRow paddingLeft={0}>
              {this.renderModule(modAtSlot, maxModuleHeight, islandMaxHeight, [], {}, configuration, this.shouldModuleBeHighlighted(modAtSlot.slot, modAtSlot.moduleType, islandSlot, rackLocation))}
            </InlineRow>
          </ModuleWithBusWrapper>
        );
      } else {
        components.push(
          <EmptySpace width={emptySpaceWidth}></EmptySpace>
        );
      }
    }

    return (<>
      {components.length > 0 && <>
        {components.map((component, idx) => {
          return <React.Fragment key={idx}>{component}</React.Fragment>
        })
        }</>}
    </>);

  }
  /**
   * Generate the M580 architecture wiring for an island.
   *
   * @param {*} moduleHeight
   * @param {*} headModuleDistance distance between the head module (from the right)
   * @param {*} isMainRack
   * @param {*} hotstandbyCorrectionOffset for hoststandby, the loop is made on the extension rack which is a copy of the main rack.
   * @param {*} bottomOffsetM580Wiring
   * @returns
   */
  generateM580ComplexWiring = (headModuleDistance, previousDistance, isMainRack, hotstandbyCorrectionOffset = 0, bottomOffsetM580Wiring) => {


    const horizontalConnectorOrigin = Math.min(headModuleDistance.rightDistanceTop, previousDistance.rightDistanceBottom);
    let rightDistanceTopToUse = headModuleDistance.rightDistanceTop - hotstandbyCorrectionOffset;
    let distance = Math.abs((previousDistance.rightDistanceBottom) - (headModuleDistance.rightDistanceTop));

    return (
      <>
        {!isMainRack && <>
          <M580VerticalWire horizontalPosition={rightDistanceTopToUse} verticalPosition={-10} color={headModuleDistance.topColor}></M580VerticalWire>
          <M580HorizontalWire horizontalPosition={horizontalConnectorOrigin} verticalPosition={-11} width={distance} color={headModuleDistance.topColor}></M580HorizontalWire>
        </>}
        <M580VerticalWire horizontalPosition={headModuleDistance.rightDistanceBottom} verticalPosition={80} height={110 + bottomOffsetM580Wiring} color={headModuleDistance.bottomColor}></M580VerticalWire>
      </>
    );
  }

  /**
   * Custom modulo function.
   *
   * @param {*} n
   * @param {*} m
   * @returns
   */
  mod(n, m) {
    return ((n % m) + m) % m;
  }

  computeHeadModuleDistance = (islandConfiguration, maxModuleHeight, realRackWidth, realRackHeight, maxRackImageWidth, opticalFiberConnection, idxToCheck) => {
    let rightDistanceTop = 0;
    let rightDistanceBottom = 0;
    let topColor = m580_complex_connection_colors.classic;
    let bottomColor= m580_complex_connection_colors.classic;

    const imageRackHeight = this.computeModuleHeight(realRackHeight, maxModuleHeight);
    const imageRackWidth = this.computeModuleWidth(realRackWidth, realRackHeight, imageRackHeight);

    if (!islandConfiguration.headModule) {
      return {
        rightDistanceTop,
        rightDistanceBottom
      };
    }

    const realHeadModuleHeight = islandConfiguration.headModule ? islandConfiguration.headModule.height : 0;
    const realHeadModuleWidth = islandConfiguration.headModule ? islandConfiguration.headModule.width : 0;

    const headModuleHeight = this.computeModuleHeight(realHeadModuleHeight, maxModuleHeight);
    const headModuleWidth = this.computeModuleWidth(realHeadModuleWidth, realHeadModuleHeight, headModuleHeight);

    if (islandConfiguration.rack) {

      const opticalFiberModuleForCurrent = opticalFiberConnection[idxToCheck];
      const opticalFiberModuleForPrevious = opticalFiberConnection[this.mod(idxToCheck - 1, opticalFiberConnection.length)];
      const opticalFiberModuleForNext = opticalFiberConnection[this.mod(idxToCheck + 1, opticalFiberConnection.length)];

      const emptySpaceWidth = this.computeModuleWidth(32, realRackHeight, imageRackHeight);

      // If connected to previous module via optical fiber
      if (opticalFiberModuleForCurrent && opticalFiberModuleForPrevious) {
        rightDistanceTop += emptySpaceWidth * ((islandConfiguration.rack?.maxIoModules || 0) - opticalFiberModuleForCurrent.slot) + (maxRackImageWidth - imageRackWidth + 40);
        rightDistanceTop += Math.ceil(emptySpaceWidth / 2.0) - 3;
        topColor = m580_complex_connection_colors.optical_fiber;
      } else {
        rightDistanceTop += emptySpaceWidth * (islandConfiguration.numberOfPacIOModulesSlots()) + (maxRackImageWidth - imageRackWidth + 40);
        rightDistanceTop += Math.ceil(headModuleWidth / 2.0) - 3;
      }

      if (opticalFiberModuleForCurrent && opticalFiberModuleForNext) {
        rightDistanceBottom += emptySpaceWidth * ((islandConfiguration.rack?.maxIoModules || 0) - opticalFiberModuleForCurrent.slot) + (maxRackImageWidth - imageRackWidth + 40);
        rightDistanceBottom += Math.ceil(emptySpaceWidth / 2.0) - 3;
        bottomColor = m580_complex_connection_colors.optical_fiber;
      } else {
        rightDistanceBottom += emptySpaceWidth * (islandConfiguration.numberOfPacIOModulesSlots()) + (maxRackImageWidth - imageRackWidth + 40);
        rightDistanceBottom += Math.ceil(headModuleWidth / 2.0) - 3;
      }
    }

    return {
      rightDistanceTop,
      rightDistanceBottom,
      imageRackWidth,
      topColor,
      bottomColor
    };
  }

  /**
   * Render the local rack configurations.
   *
   * @param {*} maxModuleHeight max module height
   * @param {*} maxWidth max rack width
   * @param {*} localRackConfigurations local rack configurations to draw
   * @param {*} previousDistance previous distance for the main configuration
   * @returns
   */
  renderLocalRackConfigurations = (maxWidth, maxModuleHeight, localRackConfigurations, connectorDestination, mainRackAndLastRackConnectionColor, islandSlot) => {


    return (
      <LocalRacksWrapper>
        {localRackConfigurations.map((rackConfiguration, idx) => {
          const isFinalRack = (idx + 1) === localRackConfigurations.length;
          const componentAndDistance = this.generateLocalRackConfiguration(maxWidth, maxModuleHeight, rackConfiguration, islandSlot, (idx + 1), connectorDestination, mainRackAndLastRackConnectionColor, isFinalRack);

          return (<Fragment key={idx}>
            {componentAndDistance.component}
          </Fragment>);
        })}
      </LocalRacksWrapper>
    );
  }

  renderRedBoxes = (maxIslandHeight, maxModuleHeight, redboxes) => {

    return(
      <>
        {redboxes.map((redbox, idx) => {

        const realHeight = redbox.height ? redbox.height : 0;
        const realWidth = redbox.width ? redbox.width : 0;
        const imageHeight = this.computeModuleHeight(realHeight, maxModuleHeight);
        const imageWidth = this.computeModuleWidth(realWidth, realHeight, imageHeight);
        const shouldModuleBeHighlighted = this.shouldModuleBeHighlighted(idx, redbox.moduleType, 0, null);
          return (
            <ModuleItem height={maxIslandHeight} key={idx}>
              <DeviceImageWrapper selected={shouldModuleBeHighlighted}>
                <DeviceImage
                  src={`${front_base_url}/images/small-devices-images/${redbox.id}_h320px.png`}
                  alt={`${redbox.id} module front view`}
                  height={imageHeight}
                  width={imageWidth}
                >
                </DeviceImage>
              </DeviceImageWrapper>
            </ModuleItem>
          );
        })}
      </>
    );
  }

  generateLocalRackConfiguration = (maxWidth, maxModuleHeight, localConfiguration, islandSlot, rackLocation, connectorDestination, mainRackAndLastRackConnectionColor, isFinalRack) => {

    const isIslandHotstandby = m580_hotstandby_ranges.includes(localConfiguration.rangeInfo?.rangeName);

    const rack = localConfiguration.rack;
    const hasRack = rack && rack.id?.length > 0;
    let width = this.computeModuleWidth((this.props.configuration?.headModule?.width || 0), (this.props.configuration?.headModule?.height || 0), 160);

    const realRackHeight = rack?.height ? rack.height : 0;
    const realRackWidth = rack?.width ? rack.width : 0;

    const imageRackHeight = this.computeModuleHeight(realRackHeight, maxModuleHeight);
    const imageRackWidth = this.computeModuleWidth(realRackWidth, realRackHeight, imageRackHeight);

    const islandHeight = this.computeModuleHeight(localConfiguration.maxModuleHeight(), maxModuleHeight);

    if (hasRack) {
      width = imageRackWidth;
    }

    const emptySpaceWidth = this.computeModuleWidth(32, realRackHeight, imageRackHeight);

    const rackWidth = width + 40;

    const prev = 0;

    const numberIoModules = localConfiguration.numberOfPacIOModulesSlots();

    const component = (
      <IslandWithBusWrapper width={rackWidth} paddingLeft={isIslandHotstandby ? 0 : maxWidth + 40}>
        {m580_hotstandby_ranges.includes(localConfiguration.rangeInfo?.rangeName) && <>
          <M580LocalVerticalLineConnector top={80} bottom={-10} right={40 + ((numberIoModules + 2) * emptySpaceWidth) - 6} color={m580_complex_connection_colors.optical_fiber}></M580LocalVerticalLineConnector>
          <M580LocalHorizontalLineConnector top={170} right={40 + ((numberIoModules + 2) * emptySpaceWidth) - 6} width={(maxWidth + 40) - (emptySpaceWidth * 2) + 12} color={m580_complex_connection_colors.optical_fiber}></M580LocalHorizontalLineConnector>
          {RENDER_M580_ARCHITECTURE_SCHEMA && <>
            <M580LocalVerticalLineConnector top={90} bottom={-20} right={connectorDestination} color={mainRackAndLastRackConnectionColor}></M580LocalVerticalLineConnector>
            <M580LocalHorizontalLineConnector top={180} right={connectorDestination} width={(maxWidth + 40) - (emptySpaceWidth / 2.0) + 6} color={mainRackAndLastRackConnectionColor}></M580LocalHorizontalLineConnector>
          </>}
        </>}

        <ViewWrapper>
          <RackWrapper width={width} height={160}>
            {hasRack && <RackImage width={imageRackWidth} height={imageRackHeight} src={`${front_base_url}/images/small-devices-images/${rack.id}_h320px.png`}></RackImage>}
            <BlockModulesWrapper>
              <ModulesWithHintWrapper>
                {this.renderPacPowerSupplies(maxModuleHeight, islandHeight, localConfiguration, islandSlot, rackLocation)}
              </ModulesWithHintWrapper>
              {!m580_hotstandby_ranges.includes(localConfiguration?.rangeInfo?.rangeName) ? <>
                <ModulesWithHintWrapper>
                  {this.renderPacIoModules(maxModuleHeight, islandHeight, localConfiguration, islandSlot, rackLocation)}
                </ModulesWithHintWrapper>
                <ModulesWithHintWrapper>
                  <ModuleWithBusWrapper>
                    <InlineRow paddingLeft={0}>
                      {this.renderHeadModule(maxModuleHeight, islandHeight, localConfiguration, islandSlot, rackLocation)}
                    </InlineRow>
                  </ModuleWithBusWrapper>
                </ModulesWithHintWrapper>
              </> :
                <>
                  <ModulesWithHintWrapper>
                    <ModuleWithBusWrapper>
                      <InlineRow paddingLeft={0}>
                        {this.renderHeadModule(maxModuleHeight, islandHeight, localConfiguration, islandSlot, rackLocation)}
                      </InlineRow>
                    </ModuleWithBusWrapper>
                  </ModulesWithHintWrapper>
                  <ModulesWithHintWrapper>
                    {this.renderPacIoModules(maxModuleHeight, islandHeight, localConfiguration, islandSlot, rackLocation)}
                  </ModulesWithHintWrapper>
                </>}
            </BlockModulesWrapper>
          </RackWrapper>
        </ViewWrapper>
        {!isIslandHotstandby && <>
          <ProtocolHorizontalLine right={-(maxWidth - imageRackWidth - 20)} top={40} width={(maxWidth + 35) - imageRackWidth}>
          </ProtocolHorizontalLine>
          <ProtocolVerticalLine right={-(maxWidth - imageRackWidth - 20)} top={-60} height={100}>
            </ProtocolVerticalLine>
        </>}
        {!isFinalRack && !isIslandHotstandby &&
          <>
            <ProtocolHorizontalLine right={-(maxWidth - imageRackWidth - 20)} bottom={160 - imageRackHeight + 20} width={(maxWidth + 35) - imageRackWidth}>
            </ProtocolHorizontalLine>
            <ProtocolVerticalLine right={-(maxWidth - imageRackWidth -20)} bottom={0} height={160 - imageRackHeight + 20}>
            </ProtocolVerticalLine>
          </>
        }
      </IslandWithBusWrapper>
    );
    return {
      component,
      prev
    };
  }

  renderIsland = (maxModuleHeight, maxWidth, islandConfiguration, islandSlot, isFinalIsland, distanceHeadModule, previousDistanceHeadModule, mainRackAndLastRackConnectionColor, isIsland = false, useLocalRackDisplay = false) => {

    const isIslandHotstandby = m580_hotstandby_ranges.includes(islandConfiguration.rangeInfo?.rangeName);
    const hasLocalRacksToRender = islandConfiguration.localRacks?.length > 0;
    const rack = islandConfiguration.rack;
    const hasRack = rack && rack.id?.length > 0;
    let width = this.computeModuleWidth((this.props.configuration?.headModule?.width || 0), (this.props.configuration?.headModule?.height || 0), 160);

    const realRackHeight = rack?.height ? rack.height : 0;
    const realRackWidth = rack?.width ? rack.width : 0;

    const imageRackHeight = this.computeModuleHeight(realRackHeight, maxModuleHeight);
    const imageRackWidth = this.computeModuleWidth(realRackWidth, realRackHeight, imageRackHeight);

    const islandHeight = this.computeModuleHeight(islandConfiguration.maxModuleHeight(), maxModuleHeight);

    const emptySpaceWidth = this.computeModuleWidth(32, realRackHeight, imageRackHeight);
    const numberIoModules = islandConfiguration.numberOfPacIOModulesSlots();

    if (hasRack) {
      width = imageRackWidth;
    }

    const isHotstandby = m580_hotstandby_ranges.includes(islandConfiguration.rangeInfo?.rangeName);
    const widthWithGap = width + 40;
    const renderM580ComplexWiring = !useLocalRackDisplay && ((!isIsland && !isFinalIsland) || isIsland);

    const connectorDestination = distanceHeadModule.rightDistanceTop - (maxWidth - imageRackWidth);

    // Hotstandby local rack needs to be aligned on the PLC line.
    const numberOfRacksOffset = Math.max((islandConfiguration.localRacks?.length || 0) - (isIslandHotstandby ? 1 : 0) , 0);
    let bottomOffsetM580Wiring = 0;
    bottomOffsetM580Wiring = numberOfRacksOffset * (160 + 40);


    return (
      <IslandAndRedboxesContainer>
        <IslandAndLocalRacksContainer isIslandHotstandby={isIslandHotstandby}>
          <IslandWithBusWrapper width={maxWidth + 40}>
            {m580_hotstandby_ranges.includes(islandConfiguration.rangeInfo?.rangeName) && <>
              <M580LocalVerticalLineConnector top={80} bottom={-16} right={((numberIoModules) * emptySpaceWidth) + ((maxWidth + 40) - imageRackWidth)} color={m580_complex_connection_colors.optical_fiber}></M580LocalVerticalLineConnector>
              {RENDER_M580_ARCHITECTURE_SCHEMA && <M580LocalVerticalLineConnector top={90} bottom={-26} right={distanceHeadModule.rightDistanceTop - (emptySpaceWidth / 2.0) + 6} color={mainRackAndLastRackConnectionColor}></M580LocalVerticalLineConnector>}
            </>}
            {RENDER_M580_ARCHITECTURE_SCHEMA && islandConfiguration.headModule && renderM580ComplexWiring && this.generateM580ComplexWiring(distanceHeadModule, previousDistanceHeadModule, !isIsland, isHotstandby ? widthWithGap : 0, bottomOffsetM580Wiring)}
            {RENDER_M580_ARCHITECTURE_SCHEMA && renderM580ComplexWiring && !isIsland && <M580HorizontalLineConnector top={40} width={distanceHeadModule.rightDistanceTop + (isIslandHotstandby ? 0 : (maxWidth + 30))} right={-maxWidth - 30} color={mainRackAndLastRackConnectionColor}></M580HorizontalLineConnector>}
            {RENDER_M580_ARCHITECTURE_SCHEMA && renderM580ComplexWiring && isIsland && isFinalIsland && <M580HorizontalLineConnector top={184 + bottomOffsetM580Wiring} width={(maxWidth + 30) + distanceHeadModule.rightDistanceBottom} right={-maxWidth - 30} color={mainRackAndLastRackConnectionColor}></M580HorizontalLineConnector>}
            {RENDER_M580_ARCHITECTURE_SCHEMA && renderM580ComplexWiring && <M580VerticalLineConnector top={isIsland ? -10 : 40} right={-maxWidth - 30} bottom={-30 - bottomOffsetM580Wiring} color={mainRackAndLastRackConnectionColor}></M580VerticalLineConnector>}
            <ViewWrapper>
              <RackWrapper width={width} height={160}>
                {hasRack && <RackImage width={imageRackWidth} height={imageRackHeight} src={`${front_base_url}/images/small-devices-images/${rack.id}_h320px.png`}></RackImage>}
                <BlockModulesWrapper>
                  <ModulesWithHintWrapper>
                    {this.renderPacPowerSupplies(maxModuleHeight, islandHeight, islandConfiguration, islandSlot, null)}
                  </ModulesWithHintWrapper>
                  {useLocalRackDisplay && isIsland ? <>
                    <ModulesWithHintWrapper>
                      {this.renderPacIoModules(maxModuleHeight, islandHeight, islandConfiguration, islandSlot, null)}
                    </ModulesWithHintWrapper>
                    <ModulesWithHintWrapper>
                      <ModuleWithBusWrapper>
                        <InlineRow paddingLeft={0}>
                          {this.renderHeadModule(maxModuleHeight, islandHeight, islandConfiguration, islandSlot, null)}
                        </InlineRow>
                      </ModuleWithBusWrapper>
                    </ModulesWithHintWrapper>
                  </> :
                    <>
                      <ModulesWithHintWrapper>
                        <ModuleWithBusWrapper>
                          <InlineRow paddingLeft={0}>
                            {this.renderHeadModule(maxModuleHeight, islandHeight, islandConfiguration, islandSlot, null)}
                          </InlineRow>
                        </ModuleWithBusWrapper>
                      </ModulesWithHintWrapper>
                      <ModulesWithHintWrapper>
                        {this.renderPacIoModules(maxModuleHeight, islandHeight, islandConfiguration, islandSlot, null)}
                      </ModulesWithHintWrapper>
                    </>}
                </BlockModulesWrapper>
              </RackWrapper>
            </ViewWrapper>
            {useLocalRackDisplay && isIsland && <>
              <ProtocolHorizontalLine right={0} top={40} width={(maxWidth + 55) - imageRackWidth}>
              </ProtocolHorizontalLine>
              <ProtocolVerticalLine right={0} top={-60} height={100}>
                </ProtocolVerticalLine>
            </>}
            {((useLocalRackDisplay && !isFinalIsland) || hasLocalRacksToRender) && !isIslandHotstandby &&
              <>
                {!isIsland && <ProtocolText bottom={160 - imageRackHeight + 30}>{I10n.get('answers.xbus_protocol.label', 'data')}</ProtocolText>}
                <ProtocolHorizontalLine right={(hasLocalRacksToRender) ? -(maxWidth + 20) : 0} bottom={160 - imageRackHeight + 20} width={((maxWidth + 55) - imageRackWidth) + (hasLocalRacksToRender ? (maxWidth + 20) : 0)}>
                </ProtocolHorizontalLine>
                <ProtocolVerticalLine right={(hasLocalRacksToRender) ? -(maxWidth + 20) : 0} bottom={0} height={160 - imageRackHeight + 20}>
                </ProtocolVerticalLine>
              </>
            }
          </IslandWithBusWrapper>
          {islandConfiguration.localRacks && this.renderLocalRackConfigurations(maxWidth, maxModuleHeight, islandConfiguration.localRacks, connectorDestination, mainRackAndLastRackConnectionColor, islandSlot)}
        </IslandAndLocalRacksContainer>
      {islandConfiguration.redboxes && this.renderRedBoxes(islandHeight, maxModuleHeight, islandConfiguration.redboxes)}
      </IslandAndRedboxesContainer>
    );
  }

  setScrollRef = element => {
    this._scrollElement = element;
  };

  render = () => {
    const maxModuleHeight = this.props.configuration.maxModuleHeightWithRemote();
    return (
      <Container>
        <Header id="modal-preview-pac-config-header">
          <TitleWrapper>
            <Title>{I10n.get('screen.config_editor.preview')}</Title>
            <CloseIcon onClick={(e) => {
              e.preventDefault();
              this.props.closeModal();
            }}>
              <MsxIcons name="close"></MsxIcons>
            </CloseIcon>
          </TitleWrapper>
          <Subtitle>{I10n.getOrDefault(`modal.${this.props.configuration.starterType}.subtitle`, I10n.get('modal.subtitle'))}</Subtitle>
        </Header>
        <Content>
          <Scrollbars ref={this.setScrollRef}>
            <ScrollbarContent showDimensions={this.state.showDimensions}>
              {this.renderConfiguration(maxModuleHeight, this.props.configuration)}
            </ScrollbarContent>
          </Scrollbars>
        </Content>
      </Container>
    );
  }
}

export default ModalPreviewPacConfiguration;
